/**
 * Whether a community may serve public tenant traffic (site + config resolution).
 * Aligns with eztech-be `findOptionalBySubdomain` (active-only) and tenant middleware.
 */
export function isCommunityPubliclyAccessible(status: string | undefined | null): boolean {
  const normalized = status?.trim().toLowerCase()
  return !normalized || normalized === 'active'
}
